/**
 * Single-flight gate for a composer's send, held from entry until the composer
 * is cleared.
 *
 * A first message on a new chat awaits `createSession` before the composer
 * clears; a second send in that window (a key-repeat Enter, a double click)
 * saw the same text and the same draft tab and created a SECOND chat running
 * the same prompt (stagetest2). The gate must NOT span the whole turn —
 * `sendMessage` awaits the entire stream, and Enter mid-turn steers.
 *
 * `tryEnter()` returns this holder's release function, or `null` when the gate
 * is held. Release is idempotent and only frees the gate for the holder that
 * took it, so a late `finally` never frees a later send's hold.
 */
export interface SendGate {
  tryEnter(): (() => void) | null
}

export function createSendGate(): SendGate {
  let holder: object | null = null
  return {
    tryEnter() {
      if (holder) return null
      const token = {}
      holder = token
      return () => { if (holder === token) holder = null }
    },
  }
}
